import { render, staticRenderFns } from "./MpServiceWorker.vue?vue&type=template&id=617bd4ba&"
import script from "./MpServiceWorker.vue?vue&type=script&lang=js&"
export * from "./MpServiceWorker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports